import React from "react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Calendar, Loader2 } from "lucide-react";
import { format } from "date-fns";

export const MonthlySummaryModal = ({
  open,
  onOpenChange,
  clients,
  monthlySummary,
  setMonthlySummary,
  creatingInvoice,
  onGenerateSummary
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-primary" />
            Generate Monthly Summary
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Client</Label>
            <Select
              value={monthlySummary.client_id}
              onValueChange={(value) => setMonthlySummary(prev => ({ ...prev, client_id: value }))}
            >
              <SelectTrigger className="bg-secondary/50 border-black/10">
                <SelectValue placeholder="Select client" />
              </SelectTrigger>
              <SelectContent>
                {clients.map(client => (
                  <SelectItem key={client.id} value={client.id}>
                    {client.name} {client.company_name && `(${client.company_name})`}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Month</Label>
              <Select
                value={String(monthlySummary.month)}
                onValueChange={(value) => setMonthlySummary(prev => ({ ...prev, month: parseInt(value) }))}
              >
                <SelectTrigger className="bg-secondary/50 border-black/10">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {Array.from({ length: 12 }, (_, i) => (
                    <SelectItem key={i + 1} value={String(i + 1)}>
                      {format(new Date(2024, i, 1), "MMMM")}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>Year</Label>
              <Select
                value={String(monthlySummary.year)}
                onValueChange={(value) => setMonthlySummary(prev => ({ ...prev, year: parseInt(value) }))}
              >
                <SelectTrigger className="bg-secondary/50 border-black/10">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[2024, 2025, 2026].map(year => (
                    <SelectItem key={year} value={String(year)}>
                      {year}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <p className="text-sm text-muted-foreground">
            This will create an invoice containing all completed bookings for the selected client in the specified month.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onGenerateSummary} disabled={creatingInvoice}>
            {creatingInvoice && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Generate Summary
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
